import breakpoints from "../__utils/breakpoints";

const button = document.querySelector(".js-btn-mobile-fixed");
const { body } = document;

const init = () => {
    if (!button) {
        return;
    }

    if (breakpoints.mobileMax.matches) {
        body.style.paddingBottom = `${button.getBoundingClientRect().height}px`;
    } else {
        body.style.paddingBottom = 0;
    }
};

export default init;
